register('blog-list', {
  onLoad() {
    const loadmore_btn = document.querySelector('.blog-pagination .js-loadmore-articles');
    loadArticles(true, loadmore_btn);
    loadmore_btn.addEventListener( 'click', (e) => {
      e.preventDefault();
      loadArticles(false, e.target);
    });

    function loadArticles( preload, loadmore_btn ){
      let link = '';
      if (!preload) {
        const elementList = [...document.querySelectorAll('.js-articles-listing .grid__item.preload')];
        elementList.forEach( el => {
          el.classList.remove('preload');
        });
        if ( elementList.length ) {
          loadArticles(true, loadmore_btn);
          return false;
        }
      }

      if (loadmore_btn) {
        link = loadmore_btn.getAttribute('data-href');
      }

      if (link == '') { return; }
      const urlParams = new URLSearchParams(link);
      const page = urlParams.get('page');
      const in_page = loadmore_btn.getAttribute('featured-in-page');
      if( page == in_page ){
        link += '&view=limit-15';
      }else{
        link += '&view=limit-14';
      }

      loadmore_btn.style.setProperty('pointer-events','none');
      fetch(link).then(function (response) {
        // The API call was successful!
        return response.text();
      }).then(function (html) {
        
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        const wrapper = document.querySelector('.js-articles-listing');
        const elementList = [...doc.querySelectorAll('.js-articles-listing .grid__item')];
        const readmore = doc.querySelector('.blog-pagination .js-loadmore-articles');

        elementList.forEach( el => {
          if (preload) {
            el.classList.add('preload');
          }
          wrapper.appendChild(el);
          //wrapper.insertBefore(el, loadmore_btn.parentNode);
        });
        loadmore_btn.style.removeProperty('pointer-events');
        if (readmore) {
          loadmore_btn.setAttribute('data-href', readmore.getAttribute('data-href'));
          if (!preload) {
            loadArticles(true, loadmore_btn);
          }
        }else{
          loadmore_btn.parentNode.style.display = 'none';
        }
      }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
      });
    }
  },
  onUnload() {
    this.container.off(this.namespace);
  },
});

load('blog-list');